import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { Router, ActivatedRoute } from '@angular/router';
import { first } from 'rxjs/operators';
import { Lightbox } from 'ngx-lightbox';
import { NgxSpinnerService } from 'ngx-spinner';
import { VgAPI } from 'videogular2/core';
import * as OT from '@opentok/client';

import { AlertService, ProctorService, OpentokService } from '../_services';
import { Globals } from '../_helpers';

@Component({
  selector: 'app-videos',
  templateUrl: './videos.component.html',
  styleUrls: ['./videos.component.css'],
  providers: [OpentokService]

})
export class VideosComponent implements OnInit {

  isStudent = false;
  localExam: any
  localData: any
  localBatch = {};
  exam_id: number
  students: any
  loading = false;
  submitted = false;
  TOKEN = '';
  SESSION_ID = '';
  session: OT.Session;
  streams: Array<OT.Stream> = [];
  streaming: OT.Stream;
  changeDetectorRef: ChangeDetectorRef;
  batch_name
  exam_date
  exam_name
  link
  batchid

  @ViewChild('subscriberDiv') subscriberDiv: ElementRef;
  // @ViewChild("videoPlayer") videoplayer: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private proctorService: ProctorService,
    private alertService: AlertService,
    private globals: Globals,
    private spinner: NgxSpinnerService,
    private ref: ChangeDetectorRef,

    private opentokService: OpentokService
  ) { this.changeDetectorRef = ref; }
  ngOnInit() {
    this.localData = JSON.parse(localStorage.getItem('currentUser'))
    this.localExam = JSON.parse(localStorage.getItem('localExam'));
    this.localBatch = JSON.parse(localStorage.getItem('localBatch'));

    this.exam_id = this.localExam['exam_id']

    this.batch_name = this.localBatch['batch_name'];
    this.exam_name = this.localBatch['exam_name'];
    this.exam_date = this.localBatch['exam_date'];
    this.link=this.localData['link']
    this.batchid=this.localData['batchId']



    this.getStudentSession()
  }
  private getStudentSession() {

    this.proctorService.getSessiondata(this.globals.root_url, this.localData['usercode'], this.localExam['exam_id'])
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 1000) {
            this.students = data.details;
            this.isStudent = true;

            for (let index = 0; index < this.students.length; index++) {
              //console.log(this.students[index].stream_token);

             this.opentokService.initSession(this.students[index].stream_token,this.students[index].stream_session).then((session: OT.Session) => {   
             this.session = session;       
              this.session.on('streamCreated', (event) => {
                this.streams.push(event.stream);
                const subscriber = this.session.subscribe(event.stream, this.subscriberDiv.nativeElement, {width:280, height:220}, (err) => {
                  if (err) {
                    console.log(err.message);
                  }
                  else{
                    console.log('connect subscriber');
                  }
                });
                this.changeDetectorRef.detectChanges();
              });
              this.session.on('streamDestroyed', (event) => {
                const idx = this.streams.indexOf(event.stream);
                if (idx > -1) {
                  this.streams.splice(idx, 1);
                  this.changeDetectorRef.detectChanges();
                }
              });
            })
             .then(() => this.opentokService.connect())
              .catch((err) => {
                if (err) {
                  console.log(err.message);
                }
                else{
                  console.log('conect publisher');
                }

              });

          }
        }
          else if (data.status == 1001) {
            this.loading = false;
            this.globals.statusOpen(data.status, '/exams');


          }
          else if (data.status == 'COM_TOKEN_ERROR') {
            this.loading = false;
            this.router.navigateByUrl('/login');
          }
          else {
            this.loading = false;
            this.globals.statusOpen(data.status, '/exams');
              
          }
          this.spinner.hide();
        },
        error => {
             
          this.alertService.error(error);
          this.loading = false;
          this.spinner.hide();
            

        }
      )


  }

  // public liveStreemimg(session, token) {

    
  //   document.getElementsByTagName('body')[0].style.overflow = "hidden";
  //   let livevideo = document.getElementById('livevideo');
  //   livevideo.style.display = 'block';

 
  //   this.TOKEN = token;
  //   this.SESSION_ID = session;
  
  //   this.opentokService.initSession(this.TOKEN, this.SESSION_ID).then((session: OT.Session) => {
  //     this.session = session;
  //     this.session.on('streamCreated', (event) => {
  //       const subscriber = this.session.subscribe(event.stream, this.subscriberDiv.nativeElement, {}, (err) => {
  //         if (err) {
  //           console.log(err.message);
  //         }
  //       });
  //       this.changeDetectorRef.detectChanges();
  //     });
  //     this.session.on('streamDestroyed', (event) => {
  //       const idx = this.streams.indexOf(event.stream);
  //       if (idx > -1) {
  //         this.streams.splice(idx, 1);
  //         this.changeDetectorRef.detectChanges();
  //       }
  //     });
  //   })
  //     .then(() => this.opentokService.connect())
  //     .catch((err) => {
  //       if (err) {
  //         console.error(err.message);
  //         this.globals.statusOpen(err.message);
  //       }
  //     });

  // }


  // public customModalClose(modal_id: string) {
  //   document.getElementsByTagName('body')[0].style.overflow = "auto";
  //   let modal = document.getElementById(modal_id);
  //   modal.style.display = 'none';
  // }

  public back(){
    let batch_id = window.btoa(this.batchid)
     this.router.navigateByUrl('/exams-link/' + batch_id);

}

}
